export abstract class BaseModel {
    protected constructor(public id?: number,
                          public created_at?: string,
                          public updated_at?: string) {
    }
}
